import { render, staticRenderFns } from "./GetCard.vue?vue&type=template&id=64d4c828&scoped=true&"
import script from "./GetCard.vue?vue&type=script&lang=js&"
export * from "./GetCard.vue?vue&type=script&lang=js&"
import style0 from "./GetCard.vue?vue&type=style&index=0&id=64d4c828&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d4c828",
  null
  
)

export default component.exports